import { useAuth } from '../context/authContext';
import { hasAdvancedFeatures } from '../config/features.config';
import { getActiveOrganisationUuid } from '../utils/organisation';

/**
 * Resolves feature access for the currently active organisation.
 *
 * The active organisation is identified by its integer `id`, while the
 * allowlist is keyed on the organisation UUID (the `organisationId` field on
 * the organisation record, shown next to the header switcher).
 *
 * @returns {{ advancedFeaturesEnabled: boolean, organisationUuid: string }}
 */
export const useFeatureAccess = () => {
    const { user } = useAuth();
    const organisationUuid = getActiveOrganisationUuid(user);
    const advancedFeaturesEnabled = hasAdvancedFeatures(organisationUuid);
    return { advancedFeaturesEnabled, organisationUuid };
};
